import { ReactNode } from "react";

type ErpActionBarProps = {
  children: ReactNode;
  className?: string;
};

export default function ErpActionBar({ children, className = "" }: ErpActionBarProps) {
  return (
    <div className={`rwd-action-grid ${className}`.trim()}>
      {children}
    </div>
  );
}
